import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import CartPage from "../pages/CartPage";
import ThankYouPage from "../pages/ThankYouPage";
import LoginPage from "../pages/LoginPage";
import CrearCuentaPage from "../pages/CrearCuentaPage";
import RoleMenuPage from "../pages/RoleMenuPage";
import VendorPage from "../pages/roles/VendorPage";
import ProductosVendedorPage from "../pages/roles/ProductosVendedorPage";
import ProductoAgregarPage from "../pages/roles/ProductoAgregarPage";
import EditarVendedorPage from "../pages/roles/EditarVendedorPage";
import { ProductVendorProvider } from "../context/ProductVendorContext";
import AboutPage from "../pages/AboutPage";
import ChekoutPage from "../pages/ChekoutPage";
import DetalleProducto from "../pages/roles/DetalleProducto";
import AdminPage from "../pages/roles/admin/AdminPage";
import VerUsuario from "../pages/roles/admin/VerUsuario";
import AdminUsuario from "../pages/roles/admin/AdminUsuario";
import TerminosCondiciones from "../pages/roles/admin/TerminosCondiciones";
import PoliticaPrivacidad from "../pages/roles/admin/PoliticaPrivacidad";
import PoliticaDevoluciones from "../pages/roles/admin/PoliticaDevoluciones";
import InformacionComercio from "../pages/roles/admin/InformacionComercio";
import LibroReclamaciones from "../pages/roles/admin/LibroReclamaciones";
import MuroPage from "../pages/MuroPage";


 

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/crear-cuenta" element={<CrearCuentaPage />} />
    <Route path="/roles" element={<RoleMenuPage />} />
    <Route path="/cart" element={<CartPage />} />
    <Route path="/gracias" element={<ThankYouPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/vendor" element={<VendorPage />} />
    <Route path="/admin" element={<AdminPage />} />
    <Route path="/VerUsuario" element={<VerUsuario />} />
    <Route path="/AdminUsuario" element={<AdminUsuario />} />
    <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
<Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
<Route path="/cambios-y-devoluciones" element={<PoliticaDevoluciones />} />
<Route path="/informacion-del-comercio" element={<InformacionComercio />} />
<Route path="/muro" element={<MuroPage />} />

    <Route
      path="/vendedor/:userId"
      element={
        <ProductVendorProvider>
          <ProductosVendedorPage />
        </ProductVendorProvider>
      }
    />
<Route 
  path="/libro-de-reclamaciones" 
  element={<LibroReclamaciones />} 
/>
    <Route
      path="/vendedor/agregar/:userId"
      element={
        <ProductVendorProvider>
          <ProductoAgregarPage />
        </ProductVendorProvider>
      }
    />

    <Route
      path="/producto-vendedor/:productId"
      element={
        <ProductVendorProvider>
          <EditarVendedorPage />
        </ProductVendorProvider>
      }
    />

    <Route path="/about" element={<AboutPage />} />
    <Route path="/chekout" element={<ChekoutPage />} />
    <Route path="/detalle/:id" element={<DetalleProducto />} />

    {/* 👇 RUTA LEGAL */}
    <Route
      path="/terminos-y-condiciones"
      element={<TerminosCondiciones />}
    />
    {/* 👇 RUTAS LEGALES */}
<Route
  path="/terminos-y-condiciones"
  element={<TerminosCondiciones />}
/>

<Route
  path="/politica-de-privacidad"
  element={<PoliticaPrivacidad />}
/>

<Route
  path="/cambios-y-devoluciones"
  element={<PoliticaDevoluciones />}
/>

<Route
  path="/informacion-del-comercio"
  element={<InformacionComercio />}
/>

  </Routes>
);

export default AppRouter;
